import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';

const ContactUs = () => {
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        // This is a dummy form for the template. In production wire this to an API or email service.
        setSubmitted(true);
    }

    return (
        <Container className="my-5">
            <Row>
                <Col md={7}>
                    <h1>Contact Us</h1>
                    <p className="text-muted">Have a project in mind? Send us a message or call for a free quote.</p>

                    <Card className="p-3 shadow-sm">
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text" placeholder="Your name" required />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" placeholder="you@example.com" required />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formPhone">
                                <Form.Label>Phone</Form.Label>
                                <Form.Control type="tel" placeholder="(555) 555-5555" />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formMessage">
                                <Form.Label>Message</Form.Label>
                                <Form.Control as="textarea" rows={4} placeholder="Tell us about your project" required />
                            </Form.Group>

                            <Button type="submit" variant="success">Send Message</Button>
                            {submitted && <div className="mt-3 text-success">Thanks — your message was received (demo).</div>}
                        </Form>
                    </Card>
                </Col>

                <Col md={5} className="mt-4 mt-md-0">
                    <h5>Get in touch</h5>
                    <p className="mb-1"><strong>Phone:</strong> (816) 352-1651</p>
                    <p className="mb-1"><strong>Email:</strong> info@nicerlawnskc.com</p>
                    <p className="mb-1"><strong>Serving:</strong> Kansas City area</p>

                    <div className="mt-4">
                        <h6 className="mb-2">Business Hours</h6>
                        <p className="mb-0">Mon - Fri: 8:00 AM - 5:00 PM</p>
                        <p className="mb-0">Sat: 9:00 AM - 2:00 PM</p>
                        <p className="mb-0">Sun: Closed</p>
                    </div>

                    <div className="mt-4">
                        <h6 className="mb-2">Location</h6>
                        <div style={{width: '100%', height: 200, background:'#e9ecef', borderRadius:8}} className="d-flex align-items-center justify-content-center text-muted">Map placeholder</div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default ContactUs;